// import React, { useEffect, useState } from "react";
// import { Link } from "react-router-dom";
// import Header from "../components/Frontend/Header";
// import Footer from "../components/Frontend/Footer";
// import FrequentlyAskedQuestion from "../components/PublicPagesReusable/FrequentlyAskedQuestion";
// import SkillAssment from "../components/PublicPagesReusable/SkillAssment";
// import WhyChoose from "../components/PublicPagesReusable/WhyChoose";
// import FameWall from "../components/Frontend/FameWallPte";
// import Testimonial from "../components/Frontend/VideoPTETestimonial";
// import Packages from "../components/Frontend/Packages";
// import WhyLove from "../components/Frontend/WhyLove";
// import { Helmet } from "react-helmet";
// import ReactGA from "react-ga";
// import ReactPixel from "react-facebook-pixel";
// import Slider from "react-slick";
// import VideoTestimonial from "../components/Frontend/VideoNaatiTestimonial";
// import CrackedCodeSlider from "../components/Frontend/Sliders/CrackedCodeSlider";
// import HeroImg from "../assets/images/On-campus-img.png";

// import SkillCard from "components/Frontend/SkillCard";
// import "../assets/css/pte-responsive.css";
// import LetsCoaching from "components/PublicPagesReusable/LetsCoaching";
// import BannerSection from "components/PublicPagesReusable/BannerSection";



// const Pte = () => {
//   const [isActive, setIsActive] = useState(false);


//   const questions = [
//     {
//       question: "How long does PTE preparation take with your PTE on campus Classes?",
//       answer: "Most students require 4-6 weeks of consistent preparation to achieve their target scores, though this depends on your current proficiency."
//     },
//     {
//       question: "Do I get a money-back guarantee?",
//       answer: "We don't offer money-back guarantees because we focus on delivering results, not refunds. Our proven methods and expert guidance ensure you succeed from the start - that's why thousands of students have achieved their target PTE scores with us."
//     },
//     {
//       question: "Do you offer both online and in-person PTE on campus Classes?",
//       answer: "Yes! We provide both online coaching and PTE on campus Classes to accommodate different learning preferences and schedules."
//     },
//     {
//       question: "How can I book a free demo class for PTE on campus Classes?",
//       answer: `You can book your free demo PTE on campus Classes by calling us on <a href="tel:+61426230061">+61 426230061</a> or emailing us at <a href="mailto:info@languageacademy.com.au">info@languageacademy.com.au</a>`
//     },
//     {
//       question: "What makes Language Academy the top PTE Institute offering PTE on campus Classes?",
//       answer: "Our combination of expert tutors, proven methodologies, AI-powered practice tools, and personalized PTE on campus Classes approach has helped thousands of students achieve their target PTE scores."
//     },
//     {
//       question: "Are there any prerequisites for joining the PTE on campus Classes?",
//       answer: "No specific prerequisites are required. Our PTE on campus Classes program is designed to help students of all English proficiency levels improve their scores and achieve their goals."
//     }
//   ]
//   useEffect(() => {
//     ReactGA.initialize("UA-157984080-1");
//     ReactGA.pageview(window.location.pathname + window.location.search);
//     
//     // ReactPixel.init("197333187452630");
//     // ReactPixel.pageView();
//   }, []);

//   const handleClick = () => {
//     setIsActive((prevState) => !prevState);
//   };

//   const CardsSlider = {
//     dots: true,
//     arrows: true,
//     infinite: true,
//     speed: 500,
//     slidesToShow: 1,
//     slidesToScroll: 1,
//     autoplay: true,
//     adaptiveHeight: true,
//     autoplaySpeed: 5000,
//   };

//   const skillData = [
//     {
//       id: 1,
//       title: "Speaking",
//       description: "Fluency, pronunciation and coherence",
//       image: "/images/web-new-images/icons/w-speak-icon.svg",
//       color: "#c42fed"
//     },
//     {
//       id: 2,
//       title: "Writing",
//       description: "Essay writing, sumarizing information",
//       image: "/images/web-new-images/icons/w-write-icon.svg",
//       color: "#6366F1"
//     },
//     {
//       id: 3,
//       title: "Reading",
//       description: "Comprehesion, vocabulary, text analysis",
//       image: "/images/web-new-images/icons/w-reading-icon.svg",
//       color: "#8B5CF6"
//     },
//     {
//       id: 4,
//       title: "Listening",
//       description: "Understanding spoken English, main ideas",
//       image: "/images/web-new-images/icons/w-listen-icon.svg",
//       color: "#7E22CE"
//     }
//   ];
//   const bannerTitle = () => {
//     return (<h1 className="primary-heading dark-blue-color">
//       TRANSFORM
//       <br className="d-block" />
//       <span className="wpl-badge pte-naati-badge text-white">
//         your PTE PERFORMANCE
//       </span>
//       <br className="d-block" /> WITH WORLD'S MOST TRUSTED
//       <br className="d-none d-md-block" />  COACHING CENTRE
//     </h1>)
//   }

//   const blueBoxText = () => {
//     return (<div className="light-blue-box">
//       Master your English language skills with tailored PTE Training on campus specifically designed for students, language learners, and aspiring immigrants.
//       <br />
//       <br />
//       As World's leading PTE institute, we help you achieve top scores on the PTE exam, improve your English proficiency, and unlock the doors to your study, career, or immigration goals through our comprehensive PTE on campus Classes.
//     </div>)
//   }

//   const letsCoachingText = () => {
    
//     return (
    
//      <h2 className="primary-heading fw-700">
//                         PREPARE FOR{" "}
//                         <span className="wpl-badge gold-badge text-white">
//                             PTE SUCCESS
//                         </span>
//                         <br />
//                         with PERSONALIZED GUIDANCE <br /> ON CAMPUS
//                     </h2>
    
    
//     )
//   }




//   const subTitleSection = () => {
//     return (<p className="sub-title">
//       Expert trainers, personalized study plans, and proven
//       strategies <br className="d-none d-md-block" /> that consistently deliver the scores you
//       need for success.
//     </p>)
//   }


//   const whyChooseSectionHeader = () => {
//     return (
//       <h2 className="primary-heading dark-blue-color text-center fw-700">
//         <span className="wpl-badge gold-badge text-white">
//           WHY CHOOSE THE PTE EXAM?
//         </span>
//         <br className="d-block" />5 REASONS IT STANDS OUT
//       </h2>
//     )
//   }
//   return (
//     <React.Fragment>
//       <Helmet>
//         <title>PTE Coaching Classes in Parramatta | LA Language Academy</title>
//         <meta name="description" content="Enrol in LA Language Academy PTE coaching classes in Parramatta with our experienced trainers, structured training and mock tests to succeed in your exam." />
//         <meta name="robots" content="index, follow" />
//         <link rel="canonical" href={`https://www.languageacademy.com.au/pte-coaching-classes-parramatta`} />
//         <meta name="twitter:card" content="summary_large_image" />
//         <meta name="twitter:site" content="@languageacademy" />
//         <meta name="twitter:title" content="PTE Coaching Classes in Parramatta | LA Language Academy" />
//         <meta name="twitter:description" content="Enrol in LA Language Academy PTE coaching classes in Parramatta with our experienced trainers, structured training and mock tests to succeed in your exam." />
//         <meta name="twitter:image" content={`https://www.languageacademy.com.au/images/logol.png`} />
//         <meta name="twitter:image:alt" content="LA Language Academy Logo" />
//         <meta property="og:url" content={`https://www.languageacademy.com.au/pte-coaching-classes-parramatta`} />
//         <meta property="og:type" content="website" />
//         <meta property="og:title" content="PTE Coaching Classes in Parramatta | LA Language Academy" />
//         <meta property="og:description" content="Enrol in LA Language Academy PTE coaching classes in Parramatta with our experienced trainers, structured training and mock tests to succeed in your exam." />
//         <meta property="og:image" content={`https://www.languageacademy.com.au/images/logol.png`} />
//         <meta property="og:image:alt" content="LA Language Academy Logo" />
//         <meta property="og:image:width" content="1200" />
//         <meta property="og:image:height" content="630" />
//       </Helmet>
//       <Header />

//       <BannerSection title={bannerTitle} blueBoxText={blueBoxText} subTitle={subTitleSection} />
//       <div className="noc-ccl-exam naati-ccl-exam what-ielts pccp-pte">
//         <div className="container">
//           <div className="row align-items-center">
//             <div className="col-md-12">
//               <h2 className="primary-heading text-center fw-700">
//                 <span className="wpl-badge text-white">WHAT IS PTE?</span>
//                 <br className="d-block" />
//                 YOUR GATEWAY TO SUCCESS <br /> IN LANGUAGE PROFICIENCY
//               </h2>
//             </div>
//             <div className="col-md-6">
//               <div className="ccl-exam-img">
//                 <img
//                   className="img-fluid"
//                   src="/images/web-new-images/pccp-img.jpg"
//                   alt="Register Now"
//                 />
//               </div>
//             </div>
//             <div className="col-md-6 what-ielts-content">
//               <p>
//                 The PTE (Pearson Test of English) is a computer-based exam
//                 that evaluates English proficiency for academic, professional,
//                 or immigration purposes.
//                 <br />
//                 <br />
//                 With its fast results and global recognition, PTE is perfect
//                 for individuals looking to demonstrate their language skills
//                 for a brighter future.
//               </p>
//             </div>
//           </div>

//           <SkillAssment skillData={skillData}  />
//         </div>
//       </div>

//       <WhyChoose whyChooseSectionHeader={whyChooseSectionHeader} />
//       <LetsCoaching title={letsCoachingText} />
//       <div className="ielts-achievment">
//         <div className="container">
//           <div className="row align-items-center">
//             <div className="col-lg-6 text-center">
//               <h2 className="primary-heading fw-700">
//                 <span className="wpl-badge text-white">
//                   OUR PROMISE TO YOU
//                 </span>
//                 <br />
//                 REAL RESULTS, REAL <br /> SUCCESS
//               </h2>
//             </div>
//             <div className="col-lg-6">
//               <div className="achievment-card">
//                 <div className="icon-wrapper">
//                   <svg
//                     width="24"
//                     height="25"
//                     viewBox="0 0 24 25"
//                     fill="none"
//                     xmlns="http://www.w3.org/2000/svg"
//                   >
//                     <path
//                       d="M12 21.6885L11.8999 21.5384C11.2053 20.4964 10.858 19.9754 10.3991 19.5983C9.99286 19.2644 9.52476 19.0139 9.02161 18.8611C8.45325 18.6885 7.82711 18.6885 6.57482 18.6885H5.2C4.07989 18.6885 3.51984 18.6885 3.09202 18.4705C2.71569 18.2787 2.40973 17.9728 2.21799 17.5965C2 17.1686 2 16.6086 2 15.4885V6.88848C2 5.76837 2 5.20832 2.21799 4.7805C2.40973 4.40417 2.71569 4.09821 3.09202 3.90646C3.51984 3.68848 4.07989 3.68848 5.2 3.68848H5.6C7.84021 3.68848 8.96031 3.68848 9.81596 4.12445C10.5686 4.50794 11.1805 5.11987 11.564 5.87251C12 6.72816 12 7.84827 12 10.0885M12 21.6885V10.0885M12 21.6885L12.1001 21.5384C12.7947 20.4964 13.142 19.9754 13.6009 19.5983C14.0071 19.2644 14.4752 19.0139 14.9784 18.8611C15.5467 18.6885 16.1729 18.6885 17.4252 18.6885H18.8C19.9201 18.6885 20.4802 18.6885 20.908 18.4705C21.2843 18.2787 21.5903 17.9728 21.782 17.5965C22 17.1686 22 16.6086 22 15.4885V6.88848C22 5.76837 22 5.20832 21.782 4.7805C21.5903 4.40417 21.2843 4.09821 20.908 3.90646C20.4802 3.68848 19.9201 3.68848 18.8 3.68848H18.4C16.1598 3.68848 15.0397 3.68848 14.184 4.12445C13.4314 4.50794 12.8195 5.11987 12.436 5.87251C12 6.72816 12 7.84827 12 10.0885"
//                       stroke="#94C23C"
//                       strokeWidth="1.5"
//                       strokeLinecap="round"
//                       strokeLinejoin="round"
//                     />
//                   </svg>
//                 </div>
//                 <div className="achievment-content">
//                   <p className="mt-2">
//                     At Language Academy, we understand the difficulty of improving weak English skills and preparing for the PTE exam. That's why we've created a methodology to address your exact struggles through our specialized PTE on campus Classes.
//                   </p>
//                   {/* <h2>OUR IMPRESSIVE STATISTICS</h2>
//                   <ul>
//                     <li>500+ Coaching Preview Sessions Completed</li>
//                     <li>500+ Registered Students</li>
//                     <li>200+ Successful Students Achieving Target Scores</li>
//                   </ul> */}
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//       <div className="sss-section">
//         <CrackedCodeSlider title={`<span className="fw-700">HEAR FROM</span> <br className="d-block" /><span className="wpl-badge pte-naati-badge text-white">OUR STUDENTS</span>`} />
//         <div className="container">
//           <div className="text-center bottom-btn-wrapper">
//             <p className="sub-heading">
//               Your Success Is Our Goal, Achieve yours today.
//             </p>
//             <Link to="/auth/register" className="primary-btn">
//               REGISTER FOR YOUR COURSE
//               <img
//                 src="/images/web-new-images/right-arrow.svg"
//                 alt="Register Now"
//               />
//             </Link>
//           </div>
//         </div>
//       </div>

//       <div className="pte-campus">
//         <div className="container">
//           <div className="row align-items-center">
//             <div className="col-lg-6 text-center">
//               <h2 className="primary-heading">
//                 <span className="wpl-badge text-white mb-4">
//                   START YOUR <br /> PTE CLASSES
//                 </span>
//                 <br />
//                 ON CAMPUS <br /> COACHING PLAN
//               </h2>
//               <p className="text-uppercase">
//                 Choose Your Preparation Package
//               </p>
//             </div>
//             <div className="col-lg-6">
//               <div className="pte-campus-list">
//                 <div className="green-package-badge mb-4">CAMPUS COACHING</div>
//                 <ul>
//                   <li>
//                     <h3>
//                       <svg
//                         width="40"
//                         height="41"
//                         viewBox="0 0 40 41"
//                         fill="none"
//                         xmlns="http://www.w3.org/2000/svg"
//                       >
//                         <rect
//                           y="0.301758"
//                           width="40"
//                           height="40"
//                           rx="20"
//                           fill="#48A75C"
//                           fillOpacity="0.12"
//                         />
//                         <path
//                           d="M28 14.3018L17 25.3018L12 20.3018"
//                           stroke="#48A75C"
//                           strokeWidth="1.8"
//                           strokeLinecap="round"
//                           strokeLinejoin="round"
//                         />
//                       </svg>{" "}
//                       IN-PERSON PTE COACHING ON CAMPUS
//                     </h3>
//                     <p>
//                       Attend classes at one of our 12 locations across Australia, India, and Nepal
//                     </p>
//                   </li>
//                   <li>
//                     <h3>
//                       <svg
//                         width="40"
//                         height="41"
//                         viewBox="0 0 40 41"
//                         fill="none"
//                         xmlns="http://www.w3.org/2000/svg"
//                       >
//                         <rect
//                           y="0.301758"
//                           width="40"
//                           height="40"
//                           rx="20"
//                           fill="#48A75C"
//                           fillOpacity="0.12"
//                         />
//                         <path
//                           d="M28 14.3018L17 25.3018L12 20.3018"
//                           stroke="#48A75C"
//                           strokeWidth="1.8"
//                           strokeLinecap="round"
//                           strokeLinejoin="round"
//                         />
//                       </svg>{" "}
//                       ONE-ON-ONE SESSIONS
//                     </h3>
//                     <p>
//                       Personal coaching tailored to your specific challenges and goals
//                     </p>
//                   </li>
//                   <li>
//                     <h3>
//                       <svg
//                         width="40"
//                         height="41"
//                         viewBox="0 0 40 41"
//                         fill="none"
//                         xmlns="http://www.w3.org/2000/svg"
//                       >
//                         <rect
//                           y="0.301758"
//                           width="40"
//                           height="40"
//                           rx="20"
//                           fill="#48A75C"
//                           fillOpacity="0.12"
//                         />
//                         <path
//                           d="M28 14.3018L17 25.3018L12 20.3018"
//                           stroke="#48A75C"
//                           strokeWidth="1.8"
//                           strokeLinecap="round"
//                           strokeLinejoin="round"
//                         />
//                       </svg>{" "}
//                       INTENSIVE WORKSHOPS
//                     </h3>
//                     <p>
//                       Participate in specialized sessions targeting high-value exam components
//                     </p>
//                   </li>
//                   <li>
//                     <h3>
//                       <svg
//                         width="40"
//                         height="41"
//                         viewBox="0 0 40 41"
//                         fill="none"
//                         xmlns="http://www.w3.org/2000/svg"
//                       >
//                         <rect
//                           y="0.301758"
//                           width="40"
//                           height="40"
//                           rx="20"
//                           fill="#48A75C"
//                           fillOpacity="0.12"
//                         />
//                         <path
//                           d="M28 14.3018L17 25.3018L12 20.3018"
//                           stroke="#48A75C"
//                           strokeWidth="1.8"
//                           strokeLinecap="round"
//                           strokeLinejoin="round"
//                         />
//                       </svg>{" "}
//                       EXTENDED SUPPORT
//                     </h3>
//                     <p>
//                       Continuous guidance until you achieve your required score
//                     </p>
//                   </li>
//                   <li>
//                     <h3>
//                       <svg
//                         width="40"
//                         height="41"
//                         viewBox="0 0 40 41"
//                         fill="none"
//                         xmlns="http://www.w3.org/2000/svg"
//                       >
//                         <rect
//                           y="0.301758"
//                           width="40"
//                           height="40"
//                           rx="20"
//                           fill="#48A75C"
//                           fillOpacity="0.12"
//                         />
//                         <path
//                           d="M28 14.3018L17 25.3018L12 20.3018"
//                           stroke="#48A75C"
//                           strokeWidth="1.8"
//                           strokeLinecap="round"
//                           strokeLinejoin="round"
//                         />
//                       </svg>{" "}
//                       EXAM BOOKING ASSISTANCE
//                     </h3>
//                     <p>
//                       Help with scheduling and preparing for your test day
//                     </p>
//                   </li>
//                 </ul>
//               </div>
//             </div>
//           </div>
//           <div className="row">
//             <div className="col-md-12">
//               <div className="text-center">
//                 <Link to="/contact" className="primary-btn">
//                   Enroll Now
//                   <img
//                     src="/images/web-new-images/right-arrow.svg"
//                     alt="Register Now"
//                   />
//                 </Link>
//               </div>
//             </div>
//           </div>
//           <div className="downlaodnow-row">

//             <div className="downlaodnow-img">
//               <img
//                 src="/images/web-new-images/welcome-img.png"
//                 alt="Register Now"
//               />
//             </div>
//             <div className="downlaodnow-content">
//               <h2>PTE APP</h2>
//               <p>
//                 Download our PTE App
//                 <br />
//                 from App Store and Play Store
//               </p>
//             </div>
//             <div className="downlaodnow-third-col">
//               <h3 className="downlaodnow-title">Download Now!</h3>
//               <div className="downlaodnow-btns">
//                 <a target="_blank" rel="noopener noreferrer" href="https://play.google.com/store/apps/details?id=com.languageacademy" className="downlaod-btn">
//                   <img
//                     src="/images/web-new-images/google-play-01.svg"
//                     alt="Register Now"
//                   />
//                 </a>
//                 <a target="_blank" rel="noopener noreferrer" href="https://apps.apple.com/au/app/la-pte/id6443614190" className="downlaod-btn">
//                   <img
//                     src="/images/web-new-images/app-store-01.svg"
//                     alt="Register Now"
//                   />
//                 </a>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       <FrequentlyAskedQuestion questions={questions} />
//       <Footer />
//     </React.Fragment >
//   );
// };

// export default Pte;

import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Header from "../components/Frontend/Header";
import Footer from "../components/Frontend/Footer";
import FrequentlyAskedQuestion from "../components/PublicPagesReusable/FrequentlyAskedQuestion";
import SkillAssment from "../components/PublicPagesReusable/SkillAssment";
import WhyChoose from "../components/PublicPagesReusable/WhyChoose";
import { Helmet } from "react-helmet";
import ReactGA from "react-ga";

import Frame1 from "../assets/images/public-pages/Frame1.svg"
import Frame2 from "../assets/images/public-pages/Frame2.svg"
import Frame3 from "../assets/images/public-pages/Frame3.svg"
import Frame4 from "../assets/images/public-pages/Frame4.svg"
import Frame5 from "../assets/images/public-pages/Frame5.svg";
import Frame6 from "../assets/images/public-pages/Frame6.svg";
import Frame7 from "../assets/images/public-pages/Frame7.svg";
import Frame8 from "../assets/images/public-pages/Frame8.svg";
import Frame9 from "../assets/images/public-pages/Frame9.svg";
import Frame10 from "../assets/images/public-pages/Frame10.svg";
import Frame11 from "../assets/images/public-pages/Frame11.svg";
import Frame12 from "../assets/images/public-pages/Frame12.svg";
import Frame13 from "../assets/images/public-pages/Frame13.svg";
import Frame14 from "../assets/images/public-pages/Frame14.svg";
import Frame15 from "../assets/images/public-pages/Frame15.svg";
import Frame16 from "../assets/images/public-pages/Frame16.svg";
import Frame17 from "../assets/images/public-pages/Frame17.svg";
import Frame18 from "../assets/images/public-pages/Frame18.svg";
import Frame19 from "../assets/images/public-pages/Frame19.svg";
import Speaking from "../assets/images/public-pages/core-speaking.svg";
import Writing from "../assets/images/public-pages/core-writing.svg";
import Reading from "../assets/images/public-pages/core-reading.svg"
import Listening from "../assets/images/public-pages/core-listening.svg"

import Report from "../assets/images/public-pages/report.svg";
import CheckList from "../assets/images/public-pages/check-list.svg";
import Filter from "../assets/images/public-pages/filter.svg"
import Reward from "../assets/images/public-pages/flexible-icon.svg"
import Global from "../assets/images/public-pages/reward.svg"

// import bannerImage from "../assets/images/public-pages/pte-parramatta.png"
import bannerImage from "../assets/images/public-pages/New-Public-banner.webp"
import ReactPixel from "react-facebook-pixel";
import CrackedCodeSlider from "../components/Frontend/Sliders/CrackedCodeSlider";
import LetsCoaching from "components/PublicPagesReusable/LetsCoaching";
import BannerSection from "components/PublicPagesReusable/BannerSection";
import "../assets/css/pte-responsive.css";
import Immigration from "../assets/images/public-pages/Immigration-parramatta.png";
import ImmigrationSecond from "../assets/images/public-pages/Immigration-second.svg";
import PteDashboardImage from "../assets/images/public-pages/Newdashboard.png"
import BannerHeader from "components/PublicPagesReusable/BannerHeader";
import ReusableHomePageSlider from "./ReusableHomePageSlider";
import ButtonComp from "components/PublicPagesReusable/ButtonComp";
import ContentImageSection from "components/PublicPagesReusable/ContentImageSection";
import SkillAreas from "components/PublicPagesReusable/SkillAreas";
import ComparisonSection from "components/PublicPagesReusable/ComparisionSection";
import SplitSection from "components/PublicPagesReusable/SplitSection";
import TestSection from "components/PublicPagesReusable/TestSection";
import PromiseSection from "components/PublicPagesReusable/PromiseSection";
import TestimonialSection from "components/PublicPagesReusable/TestimonialSection";
import AiPower from "components/PublicPagesReusable/AiPowerSection";
import PteAppBanner from "components/PublicPagesReusable/PteAppBanner";
import FaqSection from "components/PublicPagesReusable/FaqSection";
import ContentPriceSection from "components/PublicPagesReusable/ContentPriceSection";
import HeroSectionUpdated from "components/PublicPagesReusable/HeroSectionUpdated";
import { PricingCard } from "./Home";
import AppBannerCustom from "components/PublicPagesReusable/AppBannerCustom";
import AppDownloadPopup from "components/Frontend/AppDownloadPopup";
 
const questions = [
  {
    question: "How long does PTE preparation take with your PTE on campus Classes?",
    answer:
      "Most students require 4-6 weeks of consistent preparation to achieve their target scores, though this depends on your current proficiency.",
  },
  {
    question: "Do I get a money-back guarantee?",
    answer:
      "We don't offer money-back guarantees because we focus on delivering results, not refunds. Our proven methods and expert guidance ensure you succeed from the start - that's why thousands of students have achieved their target PTE scores with us.",
  },
  {
    question: "Do you offer both online and in-person PTE on campus Classes?",
    answer:
      "Yes! We provide both online coaching and PTE on campus Classes to accommodate different learning preferences and schedules.",
  },
  {
    question: "How can I book a free demo class for PTE on campus Classes?",
    answer: `You can book your free demo PTE on campus Classes by calling us on <a href="tel:+61426230061">+61 426230061</a> or emailing us at <a href="mailto:info@languageacademy.com.au">info@languageacademy.com.au</a>`,
  },
  {
    question:
      "What makes Language Academy the top PTE Institute offering PTE on campus Classes?",
    answer:
      "Our combination of expert tutors, proven methodologies, AI-powered practice tools, and personalized PTE on campus Classes approach has helped thousands of students achieve their target PTE scores.",
  },
  {
    question:
      "Are there any prerequisites for joining the PTE on campus Classes?",
    answer:
      "No specific prerequisites are required. Our PTE on campus Classes program is designed to help students of all English proficiency levels improve their scores and achieve their goals.",
  },
];
 
const skillData = [
  {
    id: 1,
    title: "Speaking",
    description: "Fluency, pronunciation and coherence",
    image: "/images/web-new-images/icons/w-speak-icon.svg",
    color: "#c42fed",
  },
  {
    id: 2,
    title: "Writing",
    description: "Essay writing, sumarizing information",
    image: "/images/web-new-images/icons/w-write-icon.svg",
    color: "#6366F1",
  },
  {
    id: 3,
    title: "Reading",
    description: "Comprehesion, vocabulary, text analysis",
    image: "/images/web-new-images/icons/w-reading-icon.svg",
    color: "#8B5CF6",
  },
  {
    id: 4,
    title: "Listening",
    description: "Understanding spoken English, main ideas",
    image: "/images/web-new-images/icons/w-listen-icon.svg",
    color: "#7E22CE",
  },
];
 
const images = [{
      src: Frame1,
      alt: "score-1",
    },
    {
      src: Frame2,
      alt: "score-2",
    },
    {
      src: Frame3,
      alt: "score-3",
    },
    {
      src: Frame4,
      alt: "score-4",
    },
    {
      src: Frame5,
      alt: "score-5",
    },
    {
      src: Frame6,
      alt: "score-6",
    },{
      src: Frame7,
      alt: "score-7",
    },
    {
      src: Frame8,
      alt: "score-8",
    },
    {
      src: Frame9,
      alt: "score-9",
    },
    {
      src: Frame10,
      alt: "score-10",
    },
    {
      src: Frame11,
      alt: "score-11",
    },
    {
      src: Frame12,
      alt: "score-12",
    },
    {
      src: Frame13,
      alt: "score-13",
    },
    {
      src: Frame14,
      alt: "score-14",
    },{
      src: Frame15,
      alt: "score-15",
    },
    {
      src: Frame16,
      alt: "score-16",
    },
    {
      src: Frame17,
      alt: "score-17",
    },
    {
      src: Frame18,
      alt: "score-18",
    },
    {
      src: Frame19,
      alt: "score-19",
    }
  ];

const bannerTitle = () => (
   <h1 className="FS56FW500 top-section-text">
        BEST <span className="text-success">PTE COACHING</span> IN PARRAMATTA, AUSTRALIA
      </h1>
);
 
// const blueBoxText = () => (
//   <div className="light-blue-box">
//     Master your English language skills with tailored PTE Training on campus
//     specifically designed for students, language learners, and aspiring
//     immigrants.
//     <br />
//     <br />
//     As World's leading PTE institute, we help you achieve top scores on the PTE
//     exam, improve your English proficiency, and unlock the doors to your study,
//     career, or immigration goals through our comprehensive PTE on campus Classes.
//   </div>
// );

const heroWorkTitle = () => {
    return (
      <h1 className="FS48 fw-500 top-section-text"> <span className="text-success fw-600">Elevate Your PTE Performance </span> 
          <br />
          With the World’s Most Trusted Coaching Centre
      </h1>
    );
  };

  const heroData = {
    badge: "50,000+ Students' Success Stories",
    title: heroWorkTitle,
    subtitle: "Expert trainers, personalized study plans, and proven strategies that consistently deliver the scores you need for success.",
    btn_prepration: { text: "Start Your PTE Coaching", onClick: () => window.location.href = '/auth/register' },
    btn_outline: { text: "Free Mock Test", variant: "outline", onClick: () => window.location.href = '/auth/register' },
    users: [
      "/images/web-new-images/new-content-slider/User-01.svg",
      "/images/web-new-images/new-content-slider/User-02.svg",
      "/images/web-new-images/new-content-slider/User-03.svg",
      "/images/web-new-images/new-content-slider/RamimRahman-demo.svg",
      "/images/web-new-images/new-content-slider/SapnaPandey-demo.svg",
    ],
    trustText: "Trusted by 50,000+ students",
    profile: {
      image: "/images/web-new-images/new-content-slider/Varun-sir-hero.webp",
      stats: [
        { value: "50K+", label: "STUDENTS" },
        { value: "95%", label: "SUCCESS RATE" },
        { value: "10+", label: "LOCATIONS" }
      ]
    },
    bottomStats: [
      { value: "8",highlight:'+', label: "Years of PTE Expertise" },
      { value: "30", highlight:'+', label: "Countries Served" },
      { value: "/5", highlight:'4.8', label: "Rated PTE Practice App" },
      { value: "-Powered", highlight:'AI', label: "Scoring Engine" }
    ]
  };


const heroDescriptionSection = () => {
    return (
    <>
    <p className="sub-title text-center FS16FW500">
      Master your English language skills with tailored PTE Training on campus
     specifically designed for students, language<br/> learners, and aspiring
     immigrants.</p>  
     <p className="sub-title text-center FS16FW500">As World's leading PTE institute, we help you achieve top scores on the PTE
     exam, improve your English proficiency, and <br /> unlock the doors to your study,
     career, or immigration goals through our comprehensive PTE on campus Classes.
    </p>
    </>)
  }
 
const letsCoachingText = () => (
  <h2 className="primary-heading fw-700">
    PREPARE FOR{" "}
    <span className="wpl-badge gold-badge text-white">PTE SUCCESS</span>
    <br />
    with PERSONALIZED GUIDANCE <br /> ON CAMPUS
  </h2>
);
 
const subTitleSection = () => (
  <p className="sub-title white">
    Expert trainers, personalized study plans, and proven strategies{" "}
    <br className="d-none d-md-block" /> that consistently deliver the scores
    you need for success.
  </p>
);

 const contentSection = () => {
    return (
      <h3 className="top-section-text FS40FW600">
        <span className="text-success FS40FW600">What Is PTE?  </span><br />
        Your Gateway To Success In Language Proficiency
      </h3>
    )
  }

  const contentSectionPricing = () => {
    return (
      <p className="top-section-text FS40FW600">
        <span className="text-success FS40FW600">Start Your PTE Classes </span>In<br />
          Parramatta On Campus Coaching Plan
      </p>
    )
  }

   const skillAreaTitle = () => {
    return (
      <h3 className="top-section-text mb-4 white FS40FW600">
        The <span className="text-success FS40FW600">PTE Exam </span>
      Covers Four Core Skills</h3>
    )
  }

  const lifestyleCards = [
      {
        title: "Speaking",
        text: "Fluency, pronunciation, and clarity of speech",
        color:"transparent",
        hoverColor: '#007AFF',
        img: Speaking,
        borderColor:'rgba(255, 255, 255, 0.24)'
      },
      {
        title: "Writing",
        text: "Summarizing, essay writing, and proper grammar usage",
        color:"transparent",
        hoverColor: "#FF3B30",
        img: Writing,
        borderColor:'rgba(255, 255, 255, 0.24)'
      },
      {
        title: "Reading",
        text: "Comprehensive, vocabulary, and text analysis",
        color:"transparent",
        hoverColor: "#FFCC00",
        img: Reading,
        borderColor:'rgba(255, 255, 255, 0.24)'
      },
      {
        title: "Listening",
        text: "Spoken English comprehension, understanding key ideas",
        color:"transparent",
        hoverColor: "#34C759",
        img: Listening,
        borderColor:'rgba(255, 255, 255, 0.24)'
      },
    ];

    const skillAreaTitle2 = () => {
    return (
      <h3 className="top-section-text FS40FW600">
        <span className="text-success FS40FW600">Why Choose The PTE Exam  </span><br />
        5 Reasons It Stands Out
      </h3>
    )
  }

   const skillAreaTitle3 = () => {
    return (
      <h3 className="top-section-text FS40FW600">
        Your
        <span className="text-success FS40FW600"> Advantages  </span><br />
        With us
      </h3>
    )
  }

  const styleCards = [
      {
        title: "Faster Results",
        text: "Get your test results within 24 hours, ensuring timely progress toward your goals.",
        color: "#141414",
        img: Report,
         boxShadow:'0 10px 25px rgba(0,0,0,0.03)',
      borderColor:'rgba(0, 0, 0, 0.05)'
      },
      {
        title: "Unbiased Scoring",
        text: "AI-powered evaluation guarantees consistent and accurate scoring every time.",
        color: "#141414",
        img: CheckList,
         boxShadow:'0 10px 25px rgba(0,0,0,0.03)',
      borderColor:'rgba(0, 0, 0, 0.05)'
      },
      {
        title: "Flexible Scheduling",
        text: "Year-round test availability and global centers for your convenience.",
        color: "#141414",
        img: Reward,
         boxShadow:'0 10px 25px rgba(0,0,0,0.03)',
      borderColor:'rgba(0, 0, 0, 0.05)'
      },
      {
        title: "Digital Format",
        text: "Designed for tech-savvy students, the computer-based approach simplifies navigation.",
        color: "#141414",
        img: Filter,
         boxShadow:'0 10px 25px rgba(0,0,0,0.03)',
      borderColor:'rgba(0, 0, 0, 0.05)'
      },
      {
        title: "Global Recognition",
        text: "Accepted by leading academic institutions and immigration authorities worldwide.",
        color: "#141414",
        img: Global,
         boxShadow:'0 10px 25px rgba(0,0,0,0.03)',
      borderColor:'rgba(0, 0, 0, 0.05)'
      },
    ];

    const styleCards2 = [
      {
        title: "AI - Enabled Practice Tools",
        text: "Experience real test-like scenarios to strengthen your performance",
        color: "#141414",
        img: Report,
         boxShadow:'0 10px 25px rgba(0,0,0,0.03)',
      borderColor:'rgba(0, 0, 0, 0.05)'
      },
      {
        title: "Tailoring Tutoring Support",
        text: "Receive guidance specific to your strengths and weaknesses.",
        color: "#141414",
        img: CheckList,
         boxShadow:'0 10px 25px rgba(0,0,0,0.03)',
      borderColor:'rgba(0, 0, 0, 0.05)'
      },
      {
        title: "Custom Study Plans",
        text: "Create a realistic roadmap for success based on your target score.",
        color: "#141414",
        img: Reward,
         boxShadow:'0 10px 25px rgba(0,0,0,0.03)',
      borderColor:'rgba(0, 0, 0, 0.05)'
      },
      {
        title: "Real-Time Feedback",
        text: "Get instant improvements in your speaking and writing skills.",
        color: "#141414",
        img: Filter,
        boxShadow:'0 10px 25px rgba(0,0,0,0.03)',
      borderColor:'rgba(0, 0, 0, 0.05)'
      },
      {
        title: "Proven Test Strategies",
        text: "Learn key techniques to excel in every section of the PTE exam.",
        color: "#141414",
        img: Global,
         boxShadow:'0 10px 25px rgba(0,0,0,0.03)',
      borderColor:'rgba(0, 0, 0, 0.05)'
      }
    ];

     const comparisionTopText = () => {
    return (
      <h3 className="top-section-text FS40FW600">
        Prepare For <span className="text-success FS40FW600">PTE Success </span> With <br /> Personalized Guidance On Campus <br />
        
      </h3>
    )
  } 

  const comparisionData = []
 
const whyChooseSectionHeader = () => (
  <h2 className="primary-heading dark-blue-color text-center fw-700">
    <span className="wpl-badge gold-badge text-white">
      WHY CHOOSE THE PTE EXAM?
    </span>
    <br className="d-block" />5 REASONS IT STANDS OUT
  </h2>
);

const blockInfo = () => 
   (
  <p className="desc block-info">Ready to start your journey to success? Call us at ,<span className="white fw-bold"> +61 426230061</span> or email us at <br /> <span className="white fw-bold">  info@languageacademy.com.au</span> for any queries and doubts you may have.</p>)

const extratitle = () => (
  <h3 className="hero-title FS40FW600 mb-3">
    What makes
      <span className="text-success FS40FW600"> Us Different</span>
  </h3>
)  

const spliteSectionData = {
    extratitle : extratitle,
    quote: "Our blend of expert tutors, innovative learning tools, & proven strategies ensures you can approach the PTE exam with confidence & competence.",
    descriptions: ["We offer both online coaching and PTE on campus Classes, perfect for students planning to pursue their higher studies.",],
    buttonText: "Start Free PTE Practice",
    onButtonClick: () => { const modal = new window.bootstrap.Modal(document.getElementById('staticBackdrop')); modal.show(); },
    image: PteDashboardImage,
    imagePosition: "right",
    bgColor: "#080F1E",
    textColor: "#ffff",
    blockInfo
  };

   const testData = {
    title: "Excel In Every",
    highlight: " PTE Skill Area",
    subtitle: "With Our Strategies",
    // description: 'Our specialized PTE Core Course helps you excel in every component of the PTE Core exam:',
    tabs: [
      {
        label: "Speaking",
        icon: <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M16.6673 10V10.8333C16.6673 14.5152 13.6825 17.5 10.0007 17.5C6.31875 17.5 3.33398 14.5152 3.33398 10.8333V10M10.0007 14.1667C8.1597 14.1667 6.66732 12.6743 6.66732 10.8333V5.83333C6.66732 3.99238 8.1597 2.5 10.0007 2.5C11.8416 2.5 13.334 3.99238 13.334 5.83333V10.8333C13.334 12.6743 11.8416 14.1667 10.0007 14.1667Z" stroke="white" stroke-width="2.25" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>,
        content: {
          leftTitle: "What It Tests",
          leftPoints: [
            "Pronunciation, fluency, and verbal clarity.",
          ],
          rightTitle: "Our PTE Approach",
          rightPoints: ["Confidence-building exercises, AI-assisted pronunciation tools, and fluency-enhancing techniques."],
        },
      },
      {
        label: "Writing",
        icon: <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clip-path="url(#clip0_2010_471)">
          <path d="M10.8346 4.99987L5.41949 6.0829C5.11699 6.1434 4.96574 6.17365 4.84257 6.24721C4.73368 6.31224 4.64107 6.40127 4.5718 6.50751C4.49344 6.62768 4.45725 6.77762 4.38487 7.07749L1.66797 18.3332M1.66797 18.3332L12.9237 15.6163C13.2236 15.5439 13.3735 15.5077 13.4937 15.4294C13.5999 15.3601 13.6889 15.2675 13.754 15.1586C13.8275 15.0354 13.8578 14.8842 13.9183 14.5817L15.0013 9.16654M1.66797 18.3332L7.98964 12.0115M17.3918 6.55707L13.4441 2.60935C13.1141 2.27934 12.9491 2.11433 12.7588 2.0525C12.5914 1.99812 12.4112 1.99812 12.2438 2.05251C12.0535 2.11433 11.8885 2.27934 11.5585 2.60935L10.9441 3.22373C10.6141 3.55375 10.4491 3.71875 10.3873 3.90903C10.3329 4.0764 10.3329 4.25669 10.3873 4.42406C10.4491 4.61433 10.6141 4.77934 10.9441 5.10935L14.8918 9.05707C15.2218 9.38708 15.3868 9.55209 15.5771 9.61391C15.7445 9.66829 15.9248 9.66829 16.0922 9.61391C16.2824 9.55209 16.4474 9.38708 16.7774 9.05706L17.3918 8.44268C17.7218 8.11267 17.8868 7.94766 17.9487 7.75739C18.0031 7.59002 18.0031 7.40973 17.9487 7.24236C17.8868 7.05209 17.7218 6.88708 17.3918 6.55707ZM9.16797 9.16654C10.0884 9.16654 10.8346 9.91273 10.8346 10.8332C10.8346 11.7537 10.0884 12.4999 9.16797 12.4999C8.24749 12.4999 7.5013 11.7537 7.5013 10.8332C7.5013 9.91273 8.24749 9.16654 9.16797 9.16654Z" stroke="white" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
          </g>
          </svg>,
        content: {
          leftTitle: "What It Tests",
          leftPoints: ["Essay composition, grammar accuracy, and passage summarization."],
          rightTitle: "Our PTE Approach",
          rightPoints: ["Proven templates, grammar refinement, and summarizing strategies to make every word count."],
        },
      },
      {
        label: "Reading",
        icon: <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10.0013 17.5L9.91792 17.3749C9.33905 16.5066 9.04962 16.0725 8.66722 15.7582C8.32868 15.4799 7.93861 15.2712 7.51931 15.1438C7.04568 15 6.52389 15 5.48032 15H4.33464C3.40121 15 2.9345 15 2.57798 14.8183C2.26438 14.6586 2.00941 14.4036 1.84962 14.09C1.66797 13.7335 1.66797 13.2668 1.66797 12.3333V5.16667C1.66797 4.23325 1.66797 3.76654 1.84962 3.41002C2.00941 3.09641 2.26438 2.84144 2.57798 2.68166C2.9345 2.5 3.40121 2.5 4.33464 2.5H4.66797C6.53481 2.5 7.46823 2.5 8.18127 2.86331C8.80848 3.18289 9.31841 3.69282 9.63799 4.32003C10.0013 5.03307 10.0013 5.96649 10.0013 7.83333M10.0013 17.5V7.83333M10.0013 17.5L10.0847 17.3749C10.6635 16.5066 10.953 16.0725 11.3354 15.7582C11.6739 15.4799 12.064 15.2712 12.4833 15.1438C12.9569 15 13.4787 15 14.5223 15H15.668C16.6014 15 17.0681 15 17.4246 14.8183C17.7382 14.6586 17.9932 14.4036 18.153 14.09C18.3346 13.7335 18.3346 13.2668 18.3346 12.3333V5.16667C18.3346 4.23325 18.3346 3.76654 18.153 3.41002C17.9932 3.09641 17.7382 2.84144 17.4246 2.68166C17.0681 2.5 16.6014 2.5 15.668 2.5H15.3346C13.4678 2.5 12.5344 2.5 11.8213 2.86331C11.1941 3.18289 10.6842 3.69282 10.3646 4.32003C10.0013 5.03307 10.0013 5.96649 10.0013 7.83333" stroke="white" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        ,
        content: {
          leftTitle: "What It Tests",
          leftPoints: ["Vocabulary comprehension, text analysis, and structure awareness."],
          rightTitle: "Our PTE Approach",
          rightPoints: ["Time management techniques, sentence reordering, and vocabulary-building exercises."],
        },
      },
      {
        label: "Listening",
        icon: <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M17.5 15V10C17.5 5.85786 14.1421 2.5 10 2.5C5.85786 2.5 2.5 5.85786 2.5 10V15M4.58333 17.5C3.43274 17.5 2.5 16.5673 2.5 15.4167V13.75C2.5 12.5994 3.43274 11.6667 4.58333 11.6667C5.73393 11.6667 6.66667 12.5994 6.66667 13.75V15.4167C6.66667 16.5673 5.73393 17.5 4.58333 17.5ZM15.4167 17.5C14.2661 17.5 13.3333 16.5673 13.3333 15.4167V13.75C13.3333 12.5994 14.2661 11.6667 15.4167 11.6667C16.5673 11.6667 17.5 12.5994 17.5 13.75V15.4167C17.5 16.5673 16.5673 17.5 15.4167 17.5Z" stroke="white" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>,
        content: {
          leftTitle: "What It Tests",
          leftPoints: ["Ability to comprehend spoken English, understand main ideas, and follow instructions."],
          rightTitle: "Our PTE Approach",
          rightPoints: ["Practice identifying key details, understanding accents, and strengthening active listening skills."],
        },
      },
    ],
    
    cta: "Get Ready to Master Every PTE Section",
  };

  const sliderList = {
    title: "What Our <br/><span>Students Say</span>",
    subtitle: "Real success stories from our learners",

    settings: {
      slidesPerView: 3,
      spaceBetween: 20,
      breakpoints: {
        0: { slidesPerView: 1 },
        768: { slidesPerView: 2 },
        1024: { slidesPerView: 3 },
      },
    },

    items: [
      {
        id: 1,
        name: "Anuska Karki",
        location: "Sydney, NSW",
        description:
          "Language Academy PTE provides structured lessons and useful exam tips. The trainers are experienced and focus on high-scoring methods. The only thing is that you need to practice consistently on your own as well. If you follow their strategies properly, you can definitely achieve your target score. Thank you Team ✨",
        image: "/images/web-new-images/new-content-slider/AnuskaKarki.svg",
      },
      {
        id: 2,
        name: "Ahmad Farooq Sethi",
        location: "Lahore, Pakistan",
        description:
          "I’m really thankful to LA ACADEMY for helping me achieve my goal. They provided regular feedback on my mock tests through WhatsApp and stayed in touch every day to check on my preparation. Their constant support and guidance made a big difference in my success. Highly recommended!",
        image: "/images/web-new-images/new-content-slider/ahmad-farooq-sethi.svg",
      },
      {
        id: 3,
        name: "Parneet Khairi",
        location: "Nigeria",
        description:
          "I had an excellent experience at this PTE language academy. The instructors are skilled, encouraging, and make concepts easy to understand. I would definitely recommend it to PTE candidates.",
        image: "/images/web-new-images/new-content-slider/ParneetKhairi.svg",
      },
      {
        id: 4,
        name: "Kavita Thavasegarasingam",
        location: "Kopay",
        description:
          "I’m so happy to share that I achieved my desired PTE score! 🎉 A big thank you to Language Academy Parramatta for their excellent coaching and continuous support. The tutors were very professional, friendly, and provided effective strategies that really helped me improve my skills. Thank you so much for all your guidance and support!🎊🎉🌟",
        image: "/images/web-new-images/new-content-slider/kavita-singham.svg",
      },
      {
        id: 5,
        name: "Savy Aulakh",
        location: "-",
        description:
          "LA academy is the best school to choose for PTE. I have taken online classes from this, and I was very happy and I got my desired score to get admission in nursing. All the staff members are very helpful: Vishika mam, tammana mam, Shefali mam. Vishika mam has especially helped me by reviewing my mock test and giving me feedback on things I need to improve. Overall, tips and strategies also worked as well as practice material is great on the portal. Thank you all for helping me.",
        image: "/images/web-new-images/new-content-slider/SavyAulakh.svg",
      },
      {
        id: 6,
        name: "Anju Kharel",
        location: "Ghorahi",
        description:
          "I had a great experience with the language academy. The teachers were supportive, classes were well-structured, and the learning environment was very positive. I achieved my desired score, which I truly appreciate. Highly recommended.",
        image: "/images/web-new-images/new-content-slider/AnjuKharel.svg",
      },
      {
        id: 7,
        name: "Gurpreet Kaur",
        location: "Melbourne, VIC",
        description:
       "I am incredibly grateful to my PTE teacher, Sneha Aggarwal, for her constant support, guidance, and encouragement throughout my preparation journey.Sneha Ma’am was always patient, approachable, and dedicated—she took the time to understand my weaknesses and helped me improve step by step. Her tips, strategies, and personalized feedback played a major role in helping me achieve my desired PTE score.",
        image: "/images/web-new-images/new-content-slider/GurpreetKaur.svg",
      },
      {
        id: 8,
        name: "Rehan Tasneem",
        location: "Hyderabad, India",
        description:
          "LA is the best platform Today I took the PTE exam today and got my desired score of 7, definitely I will recommend LA, everything will be easy, and every tutor was quite helpful specially Manan Wadhwa. in my initial day's  I wasn't sure to clear my exam but after joined LA I saw the hope light. It is a great platform.Thank you Language Academy And all respected Teachers.",
        image: "/images/web-new-images/new-content-slider/Rehan-tasneem.svg",
      },
      {
        id: 9,
        name: "Suraksha Wadhwani",
        location: "Karachi, Pakistan",
        description:
          "I strongly recommend the Language Academy for  PTE Academic. The teachers were very supportive especially, mam Amanpreet and Priyanka. They both gave me valuable feedback on every mocktest and helped me throughout my preparation.",
        image: "/images/web-new-images/new-content-slider/SurakshaWadhwani.svg",
      },
      {
        id: 10,
        name: "Jatin Patel",
        location: "Surat, Gujarat, India",
        description:
          "I’m so happy to share that I achieved my desired score in PTE with the help of LA Language Academy, Parramatta! 🎉 The tutors are super supportive, the strategies they teach are spot-on, and the practice materials really prepare you for the real exam. They kept me motivated and confident throughout the journey. Highly recommend this academy to anyone aiming for success in PTE or NAATI CCL. 💯🙌",
        image: "/images/web-new-images/new-content-slider/jatin-patel.svg",
      },
      {
        id: 11,
        name: "Tushar Singh",
        location: "Melbourne, VIC",
        description:
          "I wanted to take a moment to express my sincere gratitude for all the support and guidance you provided during my preparation for the PTE exam. Your dedication, personalized approach, and expertise played a crucial role in helping me achieve the score I desired. The resources, practice materials, and constant encouragement truly made a difference in my preparation journey. I am incredibly grateful for the positive learning environment and the invaluable lessons I have gained. Thanks to your help, I feel confident and accomplished in my achievement. Once again, thank you for everything. I will always be appreciative of your efforts in helping me succeed.",
        image: "/images/web-new-images/new-content-slider/TusharSingh.png",
      },
    ],
  };

  const faqQuestions = [
    {
      question: "How long does PTE preparation take with your PTE Training in Parramatta?",
      answer: "Most students require 4-6 weeks of consistent preparation to achieve their target scores, though this depends on your current proficiency."
    },
    {
      question: "Do I get a money-back guarantee? ",
      answer: "We don't offer money-back guarantees because we focus on delivering results, not refunds. Our proven methods and expert guidance ensure you succeed from the start - that's why thousands of students have achieved their target PTE scores with us."
    },
    {
      question: "Do you offer both online and in-person PTE Classes in Parramatta?",
      answer: "Yes! We provide both online coaching and PTE Training in Parramatta in-class sessions to accommodate different learning preferences and schedules."
    },
    {
      question: "How can I book a free demo class for PTE Coaching in Parramatta?",
      answer: "You can book your free demo PTE Classes in Parramatta by calling us on +61 426230061 or emailing us at info@languageacademy.com.au"
    },
    {
      question: "What makes Language Academy the top PTE Institute offering PTE Training in Parramatta?",
      answer: "Our combination of expert tutors, proven methodologies, AI-powered practice tools, and personalized PTE Coaching in Parramatta approach has helped thousands of students achieve their target PTE scores."
    },
    {
      question: "Are there any prerequisites for joining the PTE Classes in Parramatta?",
      answer: "No specific prerequisites are required. Our PTE Training in Parramatta program is designed to help students of all English proficiency levels improve their scores and achieve their goals."
    }
  ];
 
const Pte = () => {
    const [showDownloadModal, setShowDownloadModal] = useState(false);
  useEffect(() => {
    ReactGA.initialize("UA-157984080-1");
    ReactGA.pageview(window.location.pathname + window.location.search);
    
    // ReactPixel.init("197333187452630");
    // ReactPixel.pageView();
  }, []);
 
  return (
    <React.Fragment>
      <Helmet>
        <title>PTE Coaching Classes in Parramatta | LA Language Academy</title>
        <meta
          name="description"
          content="Enrol in LA Language Academy PTE coaching classes in Parramatta with our experienced trainers, structured training and mock tests to succeed in your exam."
        />
        <meta name="robots" content="index, follow" />
        <link
          rel="canonical"
          href="https://www.languageacademy.com.au/pte-coaching-classes-parramatta"
        />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@languageacademy" />
        <meta
          name="twitter:title"
          content="PTE Coaching Classes in Parramatta | LA Language Academy"
        />
        <meta
          name="twitter:description"
          content="Enrol in LA Language Academy PTE coaching classes in Parramatta with our experienced trainers, structured training and mock tests to succeed in your exam."
        />
        <meta
          name="twitter:image"
          content="https://www.languageacademy.com.au/images/logol.png"
        />
        <meta name="twitter:image:alt" content="LA Language Academy Logo" />
        <meta
          property="og:url"
          content="https://www.languageacademy.com.au/pte-coaching-classes-parramatta"
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:title"
          content="PTE Coaching Classes in Parramatta | LA Language Academy"
        />
        <meta
          property="og:description"
          content="Enrol in LA Language Academy PTE coaching classes in Parramatta with our experienced trainers, structured training and mock tests to succeed in your exam."
        />
        <meta
          property="og:image"
          content="https://www.languageacademy.com.au/images/logol.png"
        />
        <meta property="og:image:alt" content="LA Language Academy Logo" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
      </Helmet>
      <div className="new-design">
      <Header />
      {/* <BannerHeader className=".FS16FW500 fw-bold" btnText={"Enroll in our Program today"} title={bannerTitle}  subTitle={subTitleSection} backgroundColor='#182A4F' textColor="white" middleSection={() => {
          return (  <div style={{paddingBottom: '232px'}} className="banner-img-wrapper">
              <img
            className="banner-img"
            src={bannerImage}
            alt="LA"  
          />
          </div>)
        }} />  */}

         <HeroSectionUpdated data={heroData} />
        <div className="fame-wall off-white">
          <ReusableHomePageSlider images={images} />
        </div>

        <div className="d-flex align-items-center gap-4 flex-column pb-4 off-white">
                  {heroDescriptionSection()}
                  <ButtonComp 
              link={() => {
              const modal = new window.bootstrap.Modal(document.getElementById('staticBackdrop'));
              modal.show();
              }}
              btnText={"Book Your Free Trial Class"}
            />
        </div>

        <div className="custom-container py-5">
          <ContentImageSection
            contentSection={contentSection}
            quoteText='The PTE (Pearson Test of English) is a computer-based exam that evaluates English proficiency for academic, professional, or immigration purposes.<br/> <br/> With its fast results and global recognition, PTE is perfect for individuals looking to demonstrate their language skills for a brighter future.'
            btnLink="/auth/register"
            btnText="Start Free PTE Practice"
            btnClassName="mt-4"
            image={Immigration}
            imageClassName="immigration-test-img"
            btnImg="/images/web-new-images/new-dark-arrow.svg"
          />
        </div>

         <SkillAreas
          skillAreaTitle={skillAreaTitle}
          lifestyleCards={lifestyleCards}
          btnText={"Create Your Account"}
          img="/images/web-new-images/new-dark-arrow.svg"
          skillSubtitle={"By combining motivation with structured preparation, you'll not only excel in the PTE exam but also gain the confidence needed to succeed in real-world situations."}
        />
        <SkillAreas
          className={"skill-section"}
          background={"white"}
          color={"black"}
          skillAreaTitle={skillAreaTitle2}
          lifestyleCards={styleCards}

          img="/images/web-new-images/new-dark-arrow.svg"
          btnText={"Register For Your PTE Preparation Course Today"}
          skillSubtitle={"Don't let outdated testing systems slow you down, embrace the PTE's modern, efficient format to align with your education or residency goals."}
        />

        <ComparisonSection
                  data={comparisionData}
                  comparisionTopText={comparisionTopText}
                  comparisionDescriptionText={`Excelling in the PTE exam requires honing translation,
 interpretation, and time management abilities.<br/> Here's how we support
 your journey on campus`} 
                  btnImg="/images/web-new-images/new-dark-arrow.svg"
  />

<div className="custom-container py-2">
          <ContentImageSection
          reverse={true}
           
                       quoteText="Feeling nervous about English proficiency or unsure how to approach the PTE exam? You're not alone. Many students, professionals, and immigrants face these common challenges."
                      
                       listSectionTitle="At Language Academy, World's leading PTE institute, we're here to help you"
                       listColumns={[
                         ["Enhance your <strong>English proficiency</strong> across all skill areas",
                         "Build confidence in your <strong>test-taking abilities</strong>",
                         "Develop a clear, personalized <strong>study strategy</strong>"],
                       ]}
                       btnLink={() => {
                       const modal = new window.bootstrap.Modal(document.getElementById('staticBackdrop'));
                       modal.show();
                       }}
                       btnText="Book Your Free Trial Class"
                         
                       btnClassName="mt-2"
                       image={ImmigrationSecond}
                       imageClassName="immigration-test-img"
                       btnImg="/images/web-new-images/new-dark-arrow.svg"
          />
        </div>

        <SplitSection {...spliteSectionData} btnImg="/images/web-new-images/new-dark-arrow.svg"/>
        <SkillAreas
          className={"skill-section"}
          background={"white"}
          color={"black"}
          skillAreaTitle={skillAreaTitle3}
          lifestyleCards={styleCards2}
          btnText={"Start Working On Your PTE Success Plan"}
          skillSubtitle={"Take the guesswork out of your PTE preparation,get expert-led guidance and achieve your goals with confidence."}
        />

        <TestSection data={testData} bgColor="#080F1E" btnImg="/images/web-new-images/new-dark-arrow.svg"/>

        <PromiseSection
                  isSmallWidth={true}
                  subtitle="Our Promise To You "
                  title="Real Results, Real Success"
                  description="At<span class='fw-bold'> Language Academy</span>, we understand the difficulty of improving weak English skills <br/> and preparing for the PTE exam. That's why we've created a methodology to address <br/> your exact struggles through our specialized PTE Classes in Parramatta."
                />

        <TestimonialSection
                  extraClass={" flex-column"}
                  extraWidth={"700px"}
                  title={`<span class="hero-title FS40FW600 text-center mb-0">What Our <br/> <span class="green-text">Students' Says</span></span>`}
                  subtitle={"<span style={{maxWidth: '700px'}}>Your success is our mission. Let us guide you toward the future you've been dreaming of.</span>"}
                  showBtn={false}
                  sliderList={sliderList}
                />       

                <AiPower /> 
                
                <div className="custom-container py-5">
                {/* <ContentPriceSection
                  contentSection={contentSectionPricing}
                  quoteText='Choose Your Preparation Package'
                  btnLink="/contact"
                  btnText="Enroll Now"
                  btnClassName="mt-4"
                  showCard={true}
                  cardTitle="Campus Coaching"
                  cardSubtitle="Everything in the Online Coaching package, PLUS"
                  cardPrice="249"
                  cardFeatures={[
                    "In-Person PTE Coaching",
                    "Intensive Workshops",
                    "Exam Booking Assistance",
                    "One-on-one Sessions",
                    "Extended Support"
                  ]}
                  cardBtnText="Select Your Plan"
                  cardBtnLink="/auth/register"
                />  */}
                <div className="container py-5">
                          <div className="text-center">
                            <h3 className='main-title FS40FW600 mb-0'>Start <span className='text-success FS40FW600'>Your PTE Classes</span> In Parramatta<br/> On Campus Coaching Plan</h3>
                            <p className="quote-para FS18FW400 fw-500 py-4">Choose your preparation package</p>
                          </div>
                          <div className="row justify-content-center">
                
                            <PricingCard
                              title="PACKAGE 1"
                              subtitle="Online Coaching"
                              price="249"
                              features={[
                                "Live Virtual Classes",
                                "Personalized Feedback",
                                "Direct Trainer Access",
                                "Priority Support",
                              ]}
                              description={'Self-paced learning'}
                              img="/images/web-new-images/right-arrow-black.svg"
                            />
                
                            <PricingCard
                              title="PACKAGE 2"
                              subtitle="Campus Coaching"
                              price="249"
                              isPopular={true}
                              dark={true}
                              features={[
                                "In-Person PTE Coaching",
                                "One-on-one Sessions",
                                "Intensive Workshops",
                                "Extended Support",
                                "Exam Booking Assistance"
                              ]}
                              description={'Everything in Platform, plus'}
                              img="/images/web-new-images/new-dark-arrow.svg"
                            />
                
                            <PricingCard
                              title="MOBILE"
                              subtitle="PTE Practice App"
                              price="Free"
                              isFree={true}
                              currency="to download"
                              features={[
                                "Available on iOS & Android",
                                "Practice Questions",
                                "AI-Scored Speaking",
                                "Performance Tracking",
                              ]}
                              description={'Practice on the go'}
                              img="/images/web-new-images/right-arrow-black.svg"
                               onDownloadClick={() => setShowDownloadModal(true)}
                            />
                
                          </div>
                        </div>
                </div>

                {/* <PteAppBanner /> */}
                <AppBannerCustom
                          appName="PTE"
                          description="PTE PRACTICE"
                          mobileImage="/images/web-new-images/HomePageImage/PTE-app-1.png"
                          playStoreLink={`${import.meta.env.VITE_PTE_ANDROID_APP_URL}`}
                          appStoreLink={`${import.meta.env.VITE_PTE_IOS_APP_URL}`}
                        />
                        <FaqSection questions={faqQuestions}/>

                        <AppDownloadPopup 
                                  showDownloadModal={showDownloadModal}
                                  setShowDownloadModal={setShowDownloadModal}
                                />
      
      <Footer />
      </div>
    </React.Fragment>
  );
};
 
export default Pte;


{/*

  <div className="noc-ccl-exam naati-ccl-exam what-ielts pccp-pte">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-12">
              <h2 className="primary-heading text-center fw-700">
                <span className="wpl-badge text-white">WHAT IS PTE?</span>
                <br className="d-block" />
                YOUR GATEWAY TO SUCCESS <br /> IN LANGUAGE PROFICIENCY
              </h2>
            </div>
            <div className="col-md-6">
              <div className="ccl-exam-img">
                <img
                  className="img-fluid"
                  src="/images/web-new-images/pccp-img.jpg"
                  alt="Register Now"
                />
              </div>
            </div>
            <div className="col-md-6 what-ielts-content">
              <p>
                The PTE (Pearson Test of English) is a computer-based exam that
                evaluates English proficiency for academic, professional, or
                immigration purposes.
                <br />
                <br />
                With its fast results and global recognition, PTE is perfect for
                individuals looking to demonstrate their language skills for a
                brighter future.
              </p>
            </div>
          </div>
 
          <SkillAssment skillData={skillData} />
        </div>
      </div>
 
      <WhyChoose whyChooseSectionHeader={whyChooseSectionHeader} />
      <LetsCoaching title={letsCoachingText} />
 

  <div className="ielts-achievment">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6 text-center">
              <h2 className="primary-heading fw-700">
                <span className="wpl-badge text-white mb-4">
                  OUR PROMISE TO YOU
                </span>
                <br />
                REAL RESULTS, REAL <br /> SUCCESS
              </h2>
            </div>
            <div className="col-lg-6">
              <div className="achievment-card">
                <div className="icon-wrapper">
                  <svg
                    width="24"
                    height="25"
                    viewBox="0 0 24 25"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M12 21.6885L11.8999 21.5384C11.2053 20.4964 10.858 19.9754 10.3991 19.5983C9.99286 19.2644 9.52476 19.0139 9.02161 18.8611C8.45325 18.6885 7.82711 18.6885 6.57482 18.6885H5.2C4.07989 18.6885 3.51984 18.6885 3.09202 18.4705C2.71569 18.2787 2.40973 17.9728 2.21799 17.5965C2 17.1686 2 16.6086 2 15.4885V6.88848C2 5.76837 2 5.20832 2.21799 4.7805C2.40973 4.40417 2.71569 4.09821 3.09202 3.90646C3.51984 3.68848 4.07989 3.68848 5.2 3.68848H5.6C7.84021 3.68848 8.96031 3.68848 9.81596 4.12445C10.5686 4.50794 11.1805 5.11987 11.564 5.87251C12 6.72816 12 7.84827 12 10.0885M12 21.6885V10.0885M12 21.6885L12.1001 21.5384C12.7947 20.4964 13.142 19.9754 13.6009 19.5983C14.0071 19.2644 14.4752 19.0139 14.9784 18.8611C15.5467 18.6885 16.1729 18.6885 17.4252 18.6885H18.8C19.9201 18.6885 20.4802 18.6885 20.908 18.4705C21.2843 18.2787 21.5903 17.9728 21.782 17.5965C22 17.1686 22 16.6086 22 15.4885V6.88848C22 5.76837 22 5.20832 21.782 4.7805C21.5903 4.40417 21.2843 4.09821 20.908 3.90646C20.4802 3.68848 19.9201 3.68848 18.8 3.68848H18.4C16.1598 3.68848 15.0397 3.68848 14.184 4.12445C13.4314 4.50794 12.8195 5.11987 12.436 5.87251C12 6.72816 12 7.84827 12 10.0885"
                      stroke="#94C23C"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
                <div className="achievment-content">
                  <p className="mt-2">
                    At Language Academy, we understand the difficulty of
                    improving weak English skills and preparing for the PTE
                    exam. That's why we've created a methodology to address your
                    exact struggles through our specialized PTE on campus
                    Classes.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

   <div className="sss-section">
        <CrackedCodeSlider
          title={`<span className="fw-700">HEAR FROM</span> <br className="d-block" /><span className="wpl-badge pte-naati-badge text-white">OUR STUDENTS</span>`}
        />
        <div className="container">
          <div className="text-center bottom-btn-wrapper">
            <p className="sub-heading">
              Your Success Is Our Goal, Achieve yours today.
            </p>
            <Link to="/auth/register" className="primary-btn">
              REGISTER FOR YOUR COURSE
              <img
                src="/images/web-new-images/right-arrow.svg"
                alt="Register Now"
              />
            </Link>
          </div>
        </div>
      </div>

  <div className="pte-campus">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6 text-center">
              <h2 className="primary-heading">
                <span className="wpl-badge text-white mb-4">
                  START YOUR <br /> PTE CLASSES
                </span>
                <br />
                ON CAMPUS <br /> COACHING PLAN
              </h2>
              <p className="text-uppercase">Choose Your Preparation Package</p>
            </div>
            <div className="col-lg-6">
              <div className="pte-campus-list">
                <div className="green-package-badge mb-4">CAMPUS COACHING</div>
                <ul>
                  {[
                    {
                      title: "IN-PERSON PTE COACHING ON CAMPUS",
                      desc: "Attend classes at one of our 12 locations across Australia, India, and Nepal",
                    },
                    {
                      title: "ONE-ON-ONE SESSIONS",
                      desc: "Personal coaching tailored to your specific challenges and goals",
                    },
                    {
                      title: "INTENSIVE WORKSHOPS",
                      desc: "Participate in specialized sessions targeting high-value exam components",
                    },
                    {
                      title: "EXTENDED SUPPORT",
                      desc: "Continuous guidance until you achieve your required score",
                    },
                    {
                      title: "EXAM BOOKING ASSISTANCE",
                      desc: "Help with scheduling and preparing for your test day",
                    },
                  ].map(({ title, desc }) => (
                    <li key={title}>
                      <h3>
                        <svg
                          width="40"
                          height="41"
                          viewBox="0 0 40 41"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <rect
                            y="0.301758"
                            width="40"
                            height="40"
                            rx="20"
                            fill="#48A75C"
                            fillOpacity="0.12"
                          />
                          <path
                            d="M28 14.3018L17 25.3018L12 20.3018"
                            stroke="#48A75C"
                            strokeWidth="1.8"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>{" "}
                        {title}
                      </h3>
                      <p>{desc}</p>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
 
          <div className="row">
            <div className="col-md-12">
              <div className="text-center">
                <Link to="/contact" className="primary-btn">
                  Enroll Now
                  <img
                    src="/images/web-new-images/right-arrow.svg"
                    alt="Register Now"
                  />
                </Link>
              </div>
            </div>
          </div>
 
          <div className="downlaodnow-row">
            <div className="downlaodnow-img">
              <img
                src="/images/web-new-images/welcome-img.png"
                alt="Register Now"
              />
            </div>
            <div className="downlaodnow-content">
              <h2>PTE APP</h2>
              <p>
                Download our PTE App
                <br />
                from App Store and Play Store
              </p>
            </div>
            <div className="downlaodnow-third-col">
              <h3 className="downlaodnow-title">Download Now!</h3>
              <div className="downlaodnow-btns">
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://play.google.com/store/apps/details?id=com.languageacademy"
                  className="downlaod-btn"
                >
                  <img
                    src="/images/web-new-images/google-play-01.svg"
                    alt="Google Play Store"
                  />
                </a>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://apps.apple.com/au/app/la-pte/id6443614190"
                  className="downlaod-btn"
                >
                  <img
                    src="/images/web-new-images/app-store-01.svg"
                    alt="Apple App Store"
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      
      */}